<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>家校互通->私密成绩</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.title" placeholder="考试名称"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;"> 
                    <el-date-picker
                        style="width:150px;"
                        v-model="form.examTime"
                        type="datetime"
                        placeholder="考试时间"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>

                <div style="display: inline-block; height:40px;"> 
                    <div style="width:160px;">
                        <el-input v-model="form.gradeName" placeholder="考试年级"></el-input>
                    </div>
                </div>

                <div style="display: inline-block; height:40px;"> 
                    <div style="width:160px;">
                        <el-input v-model="form.className" placeholder="考试班级"></el-input>
                    </div>
                </div>

                <div style="display: inline-block; height:40px;"> 
                    <div style="width:160px;">
                        <el-input v-model="form.createName" placeholder="上传者"></el-input>
                    </div>
                </div>

                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">导入成绩</el-button>
                    <el-button type="primary" @click="exportExcel">导出Excel</el-button>
                </div>
            </div>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="title" label="考试名称"  :show-overflow-tooltip="true" width="180"></el-table-column>
                <el-table-column prop="examTime" label="考试时间" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="gradeName" label="考试年段" width="100"></el-table-column>
                <el-table-column prop="className" label="考试班级" width="100"></el-table-column>
                <el-table-column prop="createName" label="上传者" width="100"></el-table-column>
                <el-table-column prop="gmtCreate" label="上传时间" width="150"></el-table-column>
                <el-table-column prop="" label="通知状态" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sendStatus == 1">
                            待通知
                        </div>
                        <div v-else-if="scope.row.sendStatus == 2">
                            已通知
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="110px" style="text-align:'left'">
                    <template slot-scope="scope">
                         <el-button style="color:#387EE8;"
                            @click.native.prevent="showData(scope.row)"
                            type="text"
                            size="small">
                            查看成绩
                        </el-button>
                        <el-button style="color:#387EE8;"
                            @click.native.prevent="notice(scope.row)"
                            type="text"
                            size="small">
                            通知家长
                        </el-button>
                        <el-button  v-if="currUserId == 1 || scope.row.createBy==currUserId"
                            @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red"  v-if="currUserId == 1 || scope.row.createBy==currUserId"
                            @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <importScore ref="importScore"></importScore>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <!--查看成绩名单 -->
        <div v-if="scoreDetailsVisible">
            <scoreDetails ref="scoreDetails"></scoreDetails>
        </div>
        <!--通知家长 -->
        <div v-if="scoreNoticeVisible">
            <scoreNotice ref="scoreNotice"></scoreNotice>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../common/http';
    import importScore from './ImportScore.vue';
    import update from './Update.vue';
    import scoreDetails from './ScoreDetails.vue';
    import scoreNotice from './ScoreNotice.vue';

    export default {
        name:"ScoreList",
        data(){
            return{
                loading:false,
                loadingText:"",

                addVisible:false,
                updateVisible:false,
                scoreDetailsVisible:false,
                scoreNoticeVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    title:"",
                    deptId:"",
                    examTime:"",
                    gradeName:"",
                    className:"",
                    createName:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[],
                currUserId:""
            }
        },
        components: {
            importScore,scoreDetails,scoreNotice,update
        },
        created:function () {
            this.getDeptData();
            //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
            this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id;
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let url  = this.scoreListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    title:this.form.title,
                    examTime:this.$util.isEmpty(this.form.examTime)?'':this.form.examTime,
                    gradeName:this.form.gradeName,
                    className:this.form.className,
                    createName:this.form.createName
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['importScore'].init(this.form.deptId);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.scoreListRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            showData(row){
                // 触发详情界面
                this.scoreDetailsVisible = true;
                this.$nextTick(() => {
                    this.$refs['scoreDetails'].init(row);
                })
            },
            notice(row){
                // 通知家长界面
                this.scoreNoticeVisible = true;
                this.$nextTick(() => {
                    this.$refs['scoreNotice'].init(row);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            exportExcel(){
                let msg="导出数据只支持导出1W条，超出会导出失败，请确认当前页面总条数！";
                this.$commonFn.showConfirm2(msg,this.exportData);
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url=this.scoreExportExcelUrl;
                console.log("url:"+url);
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('title', this.form.title);
                param.append('examTime', this.$util.isEmpty(this.form.examTime)?'':this.form.examTime);
                param.append('gradeName', this.form.gradeName);
                param.append('className', this.form.className);
                param.append('createName', this.form.createName);

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '私密成绩.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error); 
                    this.loading=false;
                });
           }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/score/ScoreList.vue